/* eslint-disable */
const passwordRegExp = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;

export { passwordRegExp };
